export enum ENovaplaceBannerFormatType {
  B2B_SUPER_BANNER = 'B2B_SUPER_BANNER',
  B2B_BANNER = 'B2B_BANNER',
}

export interface INovaplaceBanner {
  campaignId: string;
  image: string;
  link: string;
  advertisement: boolean;
  additionalImage: string;
  formatType: ENovaplaceBannerFormatType;
}

export enum ENovaplaceClientType {
  Private = 'private',
  Business = 'business',
  Corporate = 'corporate',
}

export interface INovaplaceBusinessContactsPayload {
  clientType: ENovaplaceClientType;
  userLogin?: string;
  counterpartyRefs?: string[];
}

export interface INovaplaceBusinessFocusPayload extends INovaplaceBusinessContactsPayload {
  campaignId: string;
}

export interface INovaplaceBusinessActionPayload extends INovaplaceBusinessContactsPayload {
  campaignId: string;
}

export interface INovaplaceBusinessClosePayload extends INovaplaceBusinessContactsPayload {
  campaignId: string;
}

export interface INovaplaceApiResponse {
  id: string;
  jsonrpc: string;
  result: object;
}

export interface INovaplaceBusinessContactsResponse extends INovaplaceApiResponse {
  result: {
    contacts: INovaplaceBanner[];
  };
}

export interface INovaplaceBusinessFocusResponse extends INovaplaceApiResponse {
}

export interface INovaplaceBusinessCloseResponse extends INovaplaceApiResponse {
}

export interface INovaplaceBusinessActionResponse extends INovaplaceApiResponse {
  result: {
    link: string;
  };
}
